// extracted by mini-css-extract-plugin
export var readonly = "_j4-1";
export var star = "_j4-0";